import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { workflowConfigs } from '../core/workflowConfigs';
import { handleWorkflowTrigger } from '../core/workflowTrigger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useChatPanelStore from 'stateManagement/store/useChatPanelStore';

import { useGetSessionById } from 'stateManagement/queries/services/aiChat/aiChatQueries';

import { selectActionPlans } from 'stateManagement/redux/actionPlans/selector';
import { createActionPlan } from 'stateManagement/redux/actionPlans/slice';

const WorkflowButtons = ({ authReducer: { user } }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const chatSessionId = useChatPanelStore((state) => state.chatSessionId);
  const { data: chatData } = useGetSessionById(chatSessionId);
  const plans = useSelector(selectActionPlans);

  const onWorkflowClick = (workflowType) => {
    const plan = handleWorkflowTrigger(
      workflowType,
      location.pathname,
      state,
      chatSessionId,
      location.search
    );
    if (plan) {
      dispatch(createActionPlan(plan));
    }
  };

  const visibleButtons = workflowConfigs.reduce((acc, workflow) => {
    acc[workflow.id] = workflow.shouldDisplay(location);
    return acc;
  }, {});

  return plans?.some((plan) => plan.chatSessionId === chatSessionId) ||
    chatData?.createdBy?._id !== user?._id ? null : (
    <Container fluid>
      <Row className='g-2'>
        {workflowConfigs.map(
          (workflow, index) =>
            visibleButtons[workflow.id] && (
              <Col key={`${workflow.id}-${index}`} className='d-flex' xs='auto'>
                <Button
                  size='sm'
                  variant={workflow.variant}
                  className='d-flex align-items-center w-100'
                  onClick={() => onWorkflowClick(workflow.workflowType)}
                >
                  <FontAwesomeIcon
                    // @ts-ignore - FontAwesomeIcon type error
                    icon={workflow.icon}
                    className='me-2'
                  />
                  {workflow.buttonText}
                </Button>
              </Col>
            )
        )}
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
});

export default connect(mapStateToProps, {})(WorkflowButtons);
